import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';
import { AuthenticationService } from '../services/security/authentication.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';


@Component({
  selector: 'sorter',
  providers: [StorageService, AuthenticationService],
  templateUrl: './sorter.component.html',
  styleUrls: ['./sorter.component.scss']
})
export class SorterComponent implements AfterViewInit, OnInit {

  sorterContainersList: any[] = [];
  sorterConfigList: any[] = [];
  filterTitle: string;
  selectedFilter: string = 'Channel/Container config';
  storage: string;
  isLoading = false;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('Sorter Configuration');
    this.filterTitle = 'Channel/Container config';
    this.loadFilter(this.filterTitle);
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
    this.selectedFilter = filterTitle; 
    if (this.selectedFilter === 'Channel/Container config'){
      this.loadConfigContainer();
    } else if (this.selectedFilter === 'Sorter assignment config'){
      this.loadConfig();
    }
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  
  async loadConfigContainer(): Promise<void> {
    try {
        this._loadingService.register('sorterContainers.list');
        await this.getSorterContainerList();
    } catch (error) {

    } finally {
          Object.assign([], this.sorterContainersList);
          this._loadingService.resolve('sorterContainers.list');
    }
  }

  async loadConfig(): Promise<void> {
    try {
        this._loadingService.register('sorterConfig.list');
        await this.getSorterConfigList();
    } catch (error) {

    } finally {
          Object.assign([], this.sorterConfigList);
          this._loadingService.resolve('sorterConfig.list');
    }
  }

  async getSorterContainerList(): Promise<void> {
    this.sorterContainersList = await this._storageService.getSorterContainerConfigList(this._authenticationService.getStorageName(),'cellumation').toPromise();
  }

  async getSorterConfigList(): Promise<void> {
    this.sorterConfigList = await this._storageService.getSorterConfigList().toPromise();
  }


  deleteConfig(prio: number): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want to delete this assignment config?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._deleteConfig(prio);
        }
      });
  }

  private async _deleteConfig(prio: number): Promise<void> {
    try {
      this._loadingService.register('sorterConfig.list');
      await this._storageService.deleteSorterConfig(prio).toPromise();
      this._snackBarService.open('Assignment config deleted', 'Ok');
      this.loadConfig();
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to delete the assignment config'});
    } finally {
      this._loadingService.resolve('sorterConfig.list');
    }
  }


  recalculate(): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want recalculate config?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this.isLoading = true;
          this._recalculate();
        }
      });
  }

  private async _recalculate(): Promise<void> {
    try {
      await this._storageService.recalculate().toPromise();
      this._snackBarService.open('RECALCULATION OK', 'Ok');
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to recalculate'});
    } finally {
      this.isLoading = false;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/sorter/sorter.component.ts